"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sceneRequiresCurrentEntity = sceneRequiresCurrentEntity;
exports.applyEntityDependenceScan = applyEntityDependenceScan;
const constants_1 = require("./constants");
function richTextToScanString(desc) {
    if (desc === undefined || desc === null) {
        return '';
    }
    if (typeof desc === 'string') {
        return desc;
    }
    const parts = [];
    const walk = (els) => {
        if (!els)
            return;
        for (const el of els) {
            if (el.type === 'entity-list') {
                if (el.entityListParent === 'current') {
                    parts.push('parent=current');
                }
            }
            if (typeof el.content === 'string') {
                parts.push(el.content);
            }
            else if (Array.isArray(el.content)) {
                walk(el.content);
            }
            if (el.scriptCode)
                parts.push(el.scriptCode);
            if (el.condition)
                parts.push(el.condition);
            if (el.effects)
                parts.push(el.effects);
            if (el.children)
                walk(el.children);
            if (el.elseChildren)
                walk(el.elseChildren);
        }
    };
    walk(desc.elements);
    return parts.join('\n');
}
function collectEntityVariableNames(entityTypes) {
    const names = new Set();
    for (const t of entityTypes) {
        for (const v of t.variables) {
            names.add(v.name);
        }
    }
    return names;
}
function textReferencesEntityContext(text, entityVarNames) {
    if (!text) {
        return false;
    }
    for (const marker of constants_1.ENTITY_DEPENDENCE_HELPER_MARKERS) {
        if (text.includes(marker)) {
            return true;
        }
    }
    // Literal getVariable("entity_var") / ${entity_var}
    for (const name of entityVarNames) {
        if (text.includes(`getVariable("${name}")`) || text.includes(`getVariable('${name}')`)) {
            return true;
        }
        if (text.includes(`\${${name}}`) || text.includes(`$${name}`)) {
            // Prefer ${name} form; bare $name is uncommon — check ${name}
            if (text.includes(`\${${name}}`)) {
                return true;
            }
        }
        if (text.includes(`setVariable("${name}"`) || text.includes(`setVariable('${name}'`)) {
            return true;
        }
    }
    return false;
}
function sceneRequiresCurrentEntity(scene, entityTypes) {
    if (!entityTypes || entityTypes.length === 0) {
        return false;
    }
    const entityVarNames = collectEntityVariableNames(entityTypes);
    const chunks = [];
    if (scene.autoEffect) {
        chunks.push(scene.autoEffect);
    }
    for (const section of scene.sections || []) {
        chunks.push(richTextToScanString(section.description));
        for (const opt of section.options || []) {
            chunks.push(richTextToScanString(opt.text));
            if (opt.condition)
                chunks.push(opt.condition);
            if (opt.effect)
                chunks.push(opt.effect);
            chunks.push(richTextToScanString(opt.waitMessage));
        }
    }
    return textReferencesEntityContext(chunks.join('\n'), entityVarNames);
}
/**
 * Marks scenes with {@link Scene.requiresCurrentEntity} and returns dependent scene ids.
 * Returns error messages (e.g. missing_entity marked dependent).
 */
function applyEntityDependenceScan(adventure) {
    const errors = [];
    const entityTypes = adventure.entityTypes || [];
    const dependent = [];
    for (const scene of adventure.scenes || []) {
        const req = sceneRequiresCurrentEntity(scene, entityTypes);
        scene.requiresCurrentEntity = req;
        if (req) {
            dependent.push(scene.id);
            if (scene.id === constants_1.MISSING_ENTITY_SCENE_ID) {
                errors.push(`Required scene '${constants_1.MISSING_ENTITY_SCENE_ID}' must not reference current-entity context (entity-dependent).`);
            }
        }
    }
    adventure.entityDependentSceneIds = dependent;
    return errors;
}
//# sourceMappingURL=entityDependenceScan.js.map